import { Directive, inject } from '@angular/core';
import { ItemProvider, ItemProviderDirective } from '@ntap/core';
import { FastDataEntryObrasciListProviderDirective } from './fast-data-entry-obrasci-list-provider';

@Directive({
  selector: '[appFastDataEntryViewItemProvider]',
  providers: [
    {
      provide: ItemProvider,
      useExisting: FastDataEntryViewItemProviderDirective
    }
  ]
})
export class FastDataEntryViewItemProviderDirective extends ItemProviderDirective {
  obrasciListViewProvider = inject(FastDataEntryObrasciListProviderDirective);

  override updateItem(item: object): void {
    super.updateItem(item);
    this.obrasciListViewProvider.refreshPodrazineList();
  }
}
